<template>
<div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav :selectedLanguage="lang" page="gb"
      :gotodownload="gotodownload"
      :apk="apk"/>

  <div id="page" class="site container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <div class="hero-section">
            <div class="container">
              <h1 class="main-title">
                <span>{{ t.hero.title }}</span>
                <span class="main-title-accent">{{ t.hero.titleAccent }}</span>
              </h1>
              <div class="hero-tags">
                <span
                  v-for="tag in t.hero.tags"
                  :key="tag.label"
                  :class="['hero-tag', 'hero-tag--' + tag.tone]"
                >
                  <span :class="['hero-tag-icon', 'hero-tag-icon--' + tag.icon]">
                    <svg v-if="tag.icon === 'badge'" viewBox="0 0 24 24" aria-hidden="true">
                      <circle class="icon-fill" cx="12" cy="12" r="8.7" />
                      <path class="icon-accent" d="M8.3 12.1l2.35 2.35L15.9 9" />
                    </svg>
                    <svg v-else-if="tag.icon === 'refresh'" viewBox="0 0 24 24" aria-hidden="true">
                      <circle class="icon-fill" cx="12" cy="12" r="8.7" />
                      <path class="icon-accent" d="M15.8 8.8A4.9 4.9 0 0 0 8 7.7L7 8.8" />
                      <path class="icon-accent" d="M7 6.1v2.7h2.7" />
                      <path class="icon-accent" d="M8.2 15.2a4.9 4.9 0 0 0 7.8 1.1l1-1.1" />
                      <path class="icon-accent" d="M17 17.9v-2.7h-2.7" />
                    </svg>
                    <svg v-else-if="tag.icon === 'shield'" viewBox="0 0 24 24" aria-hidden="true">
                      <path
                        class="icon-fill"
                        d="M12 4.65c1.8 1.03 3.35 1.38 5.2 1.58v4.35c0 3.48-2.08 6.08-5.2 7.48-3.12-1.4-5.2-4-5.2-7.48V6.23c1.85-.2 3.4-.55 5.2-1.58z"
                      />
                      <path class="icon-accent" d="M9.35 12.15l1.8 1.78 3.65-3.78" />
                    </svg>
                  </span>
                  <span>{{ tag.label }}</span>
                </span>
              </div>
              <div class="hero-logo">
                <img src="@/assets/logo.webp" :alt="t.hero.heroAlt" />
              </div>
              <div class="download-section">
                <button class="download-btn" @click="gotodownload()" :aria-label="t.hero.downloadBtn">
                  <span class="download-icon">
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M12 5v9.2" />
                      <path d="M8.2 10.7l3.8 3.8 3.8-3.8" />
                      <path d="M7 18.5h10" />
                    </svg>
                  </span>
                  <span class="download-copy">
                    <span class="download-title">{{ t.hero.downloadTitle }}</span>
                    <span class="download-subtitle">{{ t.hero.downloadSubtitle }}</span>
                  </span>
                </button>
                <div class="hero-checks">
                  <span v-for="(item, index) in t.hero.checks" :key="'hero-check-' + index" class="hero-check">
                    <span class="hero-check-icon"></span>
                    <span>{{ item }}</span>
                  </span>
                </div>
              </div>
              <div class="hero-stats">
                <div v-for="item in t.hero.stats" :key="item.label" class="hero-stat">
                  <span :class="['hero-stat-icon', 'hero-stat-icon--' + item.icon]">
                    <svg v-if="item.icon === 'users'" viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="8.2" r="3" />
                      <circle cx="5.8" cy="10" r="2.1" />
                      <circle cx="18.2" cy="10" r="2.1" />
                      <path d="M6.7 17.5c.65-3 2.55-4.65 5.3-4.65s4.65 1.65 5.3 4.65" />
                      <path d="M2.7 17.4c.35-2.1 1.6-3.25 3.55-3.25" />
                      <path d="M21.3 17.4c-.35-2.1-1.6-3.25-3.55-3.25" />
                    </svg>
                    <svg v-else-if="item.icon === 'star'" viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="12" r="7.5" />
                      <path d="M12 8.1l1.25 2.55 2.8.4-2.02 1.98.48 2.8L12 14.5l-2.5 1.33.48-2.8-2.02-1.98 2.8-.4L12 8.1z" />
                    </svg>
                    <svg v-else-if="item.icon === 'calendar'" viewBox="0 0 24 24" aria-hidden="true">
                      <rect x="6" y="7" width="12" height="11" rx="2.2" />
                      <path d="M6 10.7h12" />
                      <path d="M9 5.8v2.6" />
                      <path d="M15 5.8v2.6" />
                      <path d="M9.1 13.4h1.2" />
                      <path d="M13.7 13.4h1.2" />
                    </svg>
                    <svg v-else-if="item.icon === 'android'" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M8.2 9.1h7.6c.85 0 1.55.7 1.55 1.55v4.9H6.65v-4.9c0-.85.7-1.55 1.55-1.55z" />
                      <path d="M9.1 9.1L7.7 6.8" />
                      <path d="M14.9 9.1l1.4-2.3" />
                      <path d="M8.7 15.55v2.65" />
                      <path d="M15.3 15.55v2.65" />
                      <path d="M4.7 11.1v4.1" />
                      <path d="M19.3 11.1v4.1" />
                      <path d="M10 12.2h.05" />
                      <path d="M14 12.2h.05" />
                    </svg>
                  </span>
                  <span class="hero-stat-copy">
                    <span class="hero-stat-value">{{ item.value }}</span>
                    <span
                      v-if="item.accent && item.accentPosition === 'beforeLabel'"
                      class="hero-stat-accent"
                    >
                      {{ item.accent }}
                    </span>
                    <span class="hero-stat-label">{{ item.label }}</span>
                    <span
                      v-if="item.accent && item.accentPosition !== 'beforeLabel'"
                      class="hero-stat-accent"
                    >
                      {{ item.accent }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="what-is-section">
            <div class="container">
              <h2 class="section-title">{{ t.whatIs.title }}</h2>
              <p v-for="(paragraph, index) in t.whatIs.paragraphs" :key="'what-' + index" class="section-description" v-html="paragraph"></p>
            </div>
          </div>

          <div class="apk-details-section">
            <div class="container">
              <h2 class="section-title">{{ t.apkDetails.title }}</h2>
              <div class="details-table">
                <div v-for="(row, index) in t.apkDetails.rows" :key="'apk-' + index" class="detail-row">
                  <div class="detail-label">{{ row.label }}</div>
                  <div class="detail-value">{{ row.value }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="screenshots-section">
            <div class="container">
              <h2 class="section-title">{{ t.screenshots.title }}</h2>
              <div class="screenshots-grid">
                <div v-for="(alt, index) in t.screenshots.alts" :key="'shot-' + index" class="screenshot-item">
                  <img :src="screenshotImages[index]" :alt="alt" />
                </div>
              </div>
            </div>
          </div>

          <div class="requirements-section">
            <div class="container">
              <h2 class="section-title">{{ t.requirements.title }}</h2>
              <p class="section-description">{{ t.requirements.description }}</p>
              <ul class="requirements-list">
                <li v-for="(item, index) in t.requirements.items" :key="'req-' + index" v-html="item"></li>
              </ul>
            </div>
          </div>

          <div class="why-choose-section">
            <div class="container">
              <h2 class="section-title">{{ t.whyChoose.title }}</h2>
              <p class="section-description">{{ t.whyChoose.description }}</p>
              <ul class="feature-list">
                <li v-for="(item, index) in t.whyChoose.items" :key="'why-' + index" v-html="item"></li>
              </ul>
              <p class="section-description">{{ t.whyChoose.closing }}</p>
            </div>
          </div>

          <div class="download-guide-section">
            <div class="container">
              <h2 class="section-title">{{ t.downloadGuide.title }}</h2>
              <p class="section-description" v-html="t.downloadGuide.description"></p>
              <h3 class="subsection-title">{{ t.downloadGuide.stepsTitle }}</h3>
              <ol class="steps-list">
                <li v-for="(step, index) in t.downloadGuide.steps" :key="'dg-step-' + index" v-html="step"></li>
              </ol>
              <h3 class="subsection-title">{{ t.downloadGuide.whyTitle }}</h3>
              <ul class="feature-list">
                <li v-for="(item, index) in t.downloadGuide.whyItems" :key="'dg-why-' + index" v-html="item"></li>
              </ul>
              <p class="section-description" v-html="t.downloadGuide.closing"></p>
            </div>
          </div>

          <div class="features-section">
            <div class="container">
              <h2 class="section-title">{{ t.features.title }}</h2>
              <div v-for="(item, index) in t.features.items" :key="'feature-' + index" class="feature-item">
                <h3 v-if="item.title" class="feature-title">{{ item.title }}</h3>
                <p class="feature-description" v-html="item.description"></p>
                <div v-if="getFeatureImage(index)" class="feature-image">
                  <img :src="getFeatureImage(index)" :alt="item.alt || ''" />
                </div>
              </div>
            </div>
          </div>

          <div class="feature-guide-section">
            <div class="container">
              <h2 class="section-title">{{ t.featureGuide.title }}</h2>
              <ol class="feature-guide-list">
                <li v-for="(item, index) in t.featureGuide.items" :key="'guide-' + index" v-html="item"></li>
              </ol>
            </div>
          </div>

          <div class="comparison-section">
            <div class="container">
              <h2 class="section-title">{{ t.comparison.title }}</h2>
              <div class="comparison-table">
                <div class="comparison-row">
                  <div class="comparison-cell feature-name">{{ t.comparison.headers[0] }}</div>
                  <div class="comparison-cell official">{{ t.comparison.headers[1] }}</div>
                  <div class="comparison-cell gb">{{ t.comparison.headers[2] }}</div>
                </div>
                <div v-for="(row, index) in t.comparison.rows" :key="'cmp-' + index" class="comparison-row">
                  <div class="comparison-cell feature-name">{{ row.feature }}</div>
                  <div class="comparison-cell official" v-html="row.official"></div>
                  <div class="comparison-cell gb" v-html="row.gb"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="install-requirements-section">
            <div class="container">
              <h2 class="section-title">{{ t.installRequirements.title }}</h2>
              <p class="section-description" v-html="t.installRequirements.description"></p>
              <ul class="requirements-list">
                <li v-for="(item, index) in t.installRequirements.items" :key="'inst-req-' + index" v-html="item"></li>
              </ul>
            </div>
          </div>

          <div class="download-steps-section">
            <div class="container">
              <h2 class="section-title">{{ t.downloadSteps.title }}</h2>
              <p class="section-description" v-html="t.downloadSteps.description"></p>
              <ol class="steps-list">
                <li v-for="(step, index) in t.downloadSteps.steps" :key="'dl-step-' + index" v-html="step"></li>
              </ol>
            </div>
          </div>

          <div class="install-steps-section">
            <div class="container">
              <h2 class="section-title">{{ t.installSteps.title }}</h2>
              <ol class="steps-list">
                <li v-for="(step, index) in t.installSteps.steps" :key="'install-step-' + index" v-html="step"></li>
              </ol>
              <p class="note-text" v-html="t.installSteps.note"></p>
              <div class="install-image">
                <img src="@/assets/home/home-16.webp" :alt="t.installSteps.installAlt" />
              </div>
            </div>
          </div>

          <div class="update-guide-section">
            <div class="container">
              <h2 class="section-title">{{ t.updateGuide.title }}</h2>
              <p class="section-description">{{ t.updateGuide.description }}</p>
              <ol class="steps-list">
                <li v-for="(step, index) in t.updateGuide.steps" :key="'update-' + index" v-html="step"></li>
              </ol>
            </div>
          </div>

          <div class="backup-guide-section">
            <div class="container">
              <h2 class="section-title">{{ t.backupGuide.title }}</h2>
              <p class="section-description">{{ t.backupGuide.description }}</p>
              <strong class="subsection-title">{{ t.backupGuide.localTitle }}</strong>
              <ol class="steps-list">
                <li v-for="(step, index) in t.backupGuide.localSteps" :key="'backup-local-' + index" v-html="step"></li>
              </ol>
              <strong class="subsection-title">{{ t.backupGuide.driveTitle }}</strong>
              <ol class="steps-list">
                <li v-for="(step, index) in t.backupGuide.driveSteps" :key="'backup-drive-' + index" v-html="step"></li>
              </ol>
              <p class="section-description" v-html="t.backupGuide.closing"></p>
            </div>
          </div>

          <div class="iphone-install-section">
            <div class="container">
              <h2 class="section-title">{{ t.iphoneInstall.title }}</h2>
              <p class="section-description" v-html="t.iphoneInstall.description"></p>
              <ol class="steps-list">
                <li v-for="(step, index) in t.iphoneInstall.steps" :key="'iphone-' + index" v-html="step"></li>
              </ol>
            </div>
          </div>

          <div class="ban-solution-section">
            <div class="container">
              <h2 class="section-title">{{ t.banSolution.title }}</h2>
              <p class="section-description">{{ t.banSolution.description }}</p>
              <ol class="steps-list">
                <li v-for="(step, index) in t.banSolution.steps" :key="'ban-' + index" v-html="step"></li>
              </ol>
              <p class="section-description" v-html="t.banSolution.closing"></p>
            </div>
          </div>

          <div class="alternatives-section">
            <div class="container">
              <h2 class="section-title">{{ t.alternatives.title }}</h2>
              <p v-for="(paragraph, index) in t.alternatives.paragraphs" :key="'alt-p-' + index" class="section-description" v-html="paragraph"></p>
              <ul class="alternatives-list">
                <li v-for="(item, index) in t.alternatives.items" :key="'alt-item-' + index" v-html="item"></li>
              </ul>
              <p class="section-description" v-html="t.alternatives.closing"></p>
            </div>
          </div>

          <div class="pros-cons-section">
            <div class="container">
              <h2 class="section-title">{{ t.prosCons.title }}</h2>
              <div class="pros-cons-grid">
                <div class="pros-column">
                  <strong class="pros-cons-title">{{ t.prosCons.prosTitle }}</strong>
                  <ul class="pros-list">
                    <li v-for="(item, index) in t.prosCons.pros" :key="'pro-' + index" v-html="item"></li>
                  </ul>
                </div>
                <div class="cons-column">
                  <strong class="pros-cons-title">{{ t.prosCons.consTitle }}</strong>
                  <ul class="cons-list">
                    <li v-for="(item, index) in t.prosCons.cons" :key="'con-' + index" v-html="item"></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="faq-section">
            <div class="container">
              <h2 class="section-title">{{ t.faq.title }}</h2>
              <div v-for="(item, index) in t.faq.items" :key="'faq-' + index" class="faq-item">
                <strong class="faq-question">{{ item.question }}</strong>
                <p class="faq-answer" v-html="item.answer"></p>
              </div>
            </div>
          </div>

          <div class="final-words-section">
            <div class="container">
              <h2 class="section-title">{{ t.finalWords.title }}</h2>
              <p v-for="(paragraph, index) in t.finalWords.paragraphs" :key="'final-' + index" class="section-description" v-html="paragraph"></p>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import homeLocales from '@/documents/home.js';
import 'swiper/css/swiper.css';

const screenshotImages = [
  require('@/assets/home/home-2.webp'),
  require('@/assets/home/home-3.webp'),
  require('@/assets/home/home-4.webp'),
];

// 功能区块配图索引映射
const featureImages = {
  0: require('@/assets/home/home-5.webp'),
  4: require('@/assets/home/home-6.webp'),
  7: require('@/assets/home/home-7.webp'),
  9: require('@/assets/home/home-8.webp'),
  10: require('@/assets/home/home-9.webp'),
  13: require('@/assets/home/home-10.webp'),
  14: require('@/assets/home/home-11.webp'),
  16: require('@/assets/home/home-12.webp'),
  18: require('@/assets/home/home-13.webp'),
  19: require('@/assets/home/home-14.webp'),
  26: require('@/assets/home/home-15.webp'),
};

export default {
  name: 'Home',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'home',
      tableHide: true,
      comment: {
        name: '',
        email: '',
        content: '',
      },
      showapk: false,
      showTableOfContents: false,

      apk: null,
      from: 'gb',
      filename: 'gb',
      clickNum: 0,
      screenshotImages,
    };
  },
  computed: {
    lang() {
      return this.$route.meta.lang || 'en';
    },
    t() {
      return homeLocales[this.lang] || homeLocales.en;
    },
    homeLink() {
      return this.lang === 'pt' ? '/pt/' : '/';
    },
    downloadURL() {
      if (typeof window === 'undefined') {
        return '/gbwhatsapp-apk-download';
      }
      const params = window.location.search;
      return `/gbwhatsapp-apk-download${params}`;
    },
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }

 

    // window.adsTag.renderInterstitial(54982);
  },
  methods: {
    getFeatureImage(index) {
      return featureImages[index] || null;
    },
    downloadClick() {
      this.$router.push({
        name: 'en-download'
      });
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      // console.log(this.apk);
      // // this.showapk = true
      // if (this.apk) {
      //   this.$global.download(this.apk);
      // }
      this.$router.push('/download/');
    },
    gotoblog() {
      this.$router.push('/blog/');
    },
    jump(url) {
      if (url && url.startsWith('/')) {
        this.$router.push(this.$global.normalizeInternalPath(url));
        return;
      }
      window.location.href = url;
    },
  
  },
};
</script>

<style scoped>
/* 缁熶竴鏍囬鏍峰紡 */
h1, h2, h3 {
  font-family: 'Arial', sans-serif;
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 1rem;
  color: #333;
}

h1 {
  font-size: 2.5rem;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 2rem;
}

h2 {
  font-size: 2rem;
  color: #34495e;
  border-bottom: 2px solid #3498db;
  padding-bottom: 0.5rem;
  margin-top: 2rem;
  margin-bottom: 1.5rem;
  position: relative;
}

h2::before{
  content: '';
  position: absolute;
  width: 5px;
  height: 100%;
  left: -20px;
  background-color: #1976d2;
}

h3 {
  font-size: 1.5rem;
  color: #2c3e50;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}

/* 椤甸潰甯冨眬鏍峰紡 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 涓昏閮ㄥ垎鏍峰紡 */
.hero-section {
  padding: 48px 0 46px;
  text-align: center;
  background: #f8fbff;
}

.main-title {
  max-width: 920px;
  margin: 0 auto 18px;
  color: #061b33;
  font-size: 48px;
  line-height: 1.12;
  letter-spacing: 0;
}

.main-title span {
  display: inline;
}

.main-title-accent {
  color: #18b957;
}

.hero-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-bottom: 30px;
}

.hero-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 7px 14px;
  border: 1px solid var(--tag-border);
  border-radius: 999px;
  background: var(--tag-bg);
  color: var(--tag-color);
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

.hero-tag--green {
  --tag-bg: #f0fff6;
  --tag-border: #bdeccd;
  --tag-color: #16a34a;
}

.hero-tag--blue {
  --tag-bg: #f1f7ff;
  --tag-border: #bdd7ff;
  --tag-color: #1677ff;
}

.hero-tag--orange {
  --tag-bg: #fff7ed;
  --tag-border: #fed7aa;
  --tag-color: #f97316;
}

.hero-tag-icon {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: currentColor;
}

.hero-tag-icon svg {
  width: 18px;
  height: 18px;
  fill: none;
  color: inherit;
  stroke: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.hero-tag-icon--refresh svg,
.hero-tag-icon--shield svg {
  width: 19px;
  height: 19px;
}

.hero-tag-icon .icon-fill {
  fill: #ffffff;
  stroke: none;
}

.hero-tag-icon .icon-accent {
  fill: none;
  stroke: currentColor;
  stroke-width: 2.35;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.hero-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 202px;
  height: 202px;
  margin: 0 auto 20px;
  position: relative;
}

.hero-logo::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: #def8e7;
  box-shadow: 0 22px 52px rgba(22, 163, 74, 0.14);
}

.hero-logo img {
  width: 154px !important;
  height: 154px !important;
  object-fit: contain;
  border-radius: 34px;
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.14);
  position: relative;
  z-index: 1;
}

.download-section {
  text-align: center;
}

.download-btn {
  width: min(100%, 430px);
  min-height: 78px;
  margin: 8px 0 18px;
  padding: 14px 34px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #ffffff !important;
  border: none !important;
  border-radius: 12px !important;
  background: linear-gradient(180deg, #1688ff 0%, #075fd5 100%) !important;
  box-shadow: 0 14px 28px rgba(7, 95, 213, 0.26);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
  text-decoration: none;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 18px 34px rgba(7, 95, 213, 0.32);
  filter: brightness(1.02);
}

.download-btn:active {
  transform: translateY(0);
  box-shadow: 0 10px 22px rgba(7, 95, 213, 0.24);
}

.download-icon {
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  border-radius: 50%;
  border: 2.5px solid rgba(255, 255, 255, 0.72);
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.08);
}

.download-icon svg {
  width: 28px;
  height: 28px;
  fill: none;
  stroke: #ffffff;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.download-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}

.download-title,
.download-subtitle {
  display: block;
  color: #ffffff;
  letter-spacing: 0;
}

.download-title {
  font-size: 20px;
  font-weight: 800;
  line-height: 26px;
}

.download-subtitle {
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  opacity: 0.92;
}

.hero-checks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 10px 0;
  margin: 0 auto 28px;
  color: #334155;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

.hero-check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 14px;
  position: relative;
}

.hero-check:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  width: 1px;
  height: 15px;
  background: #cbd5e1;
  transform: translateY(-50%);
}

.hero-check-icon {
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  border-radius: 50%;
  background: #19b85c;
  position: relative;
}

.hero-check-icon::after {
  content: '';
  position: absolute;
  top: 4px;
  left: 6px;
  width: 4px;
  height: 8px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.hero-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  max-width: 980px;
  margin: 0 auto;
}

.hero-stat {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 13px;
  min-height: 88px;
  padding: 18px 22px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(15, 23, 42, 0.04);
  text-align: left;
}

.hero-stat-icon {
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  border-radius: 50%;
  background: #18b957;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 22px rgba(24, 185, 87, 0.22);
}

.hero-stat-icon svg {
  width: 28px;
  height: 28px;
  fill: none;
  stroke: #ffffff;
  stroke-width: 2.25;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.hero-stat-icon--users circle {
  fill: #ffffff;
  stroke: none;
}

.hero-stat-icon--star circle {
  fill: #ffffff;
  stroke: none;
}

.hero-stat-icon--star path {
  fill: #18b957;
  stroke: none;
}

.hero-stat-icon--android path:first-child {
  fill: #ffffff;
  stroke: none;
}

.hero-stat-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.hero-stat-value {
  display: block;
  color: #071b34;
  font-size: 22px;
  line-height: 26px;
  font-weight: 800;
  letter-spacing: 0;
}

.hero-stat-label {
  display: block;
  color: #64748b;
  font-size: 14px;
  line-height: 18px;
  font-weight: 700;
}

.hero-stat-accent {
  display: block;
  color: #18b957;
  font-size: 14px;
  line-height: 18px;
  font-weight: 800;
}

.what-is-section ::v-deep .what-is-note {
  display: block;
  color: #7a7f87;
}

/* 閫氱敤閮ㄥ垎鏍峰紡 */
.section-description {
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  color: #555;
}

.feature-list, .requirements-list, .steps-list, .feature-guide-list, .alternatives-list {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

.feature-list li, .requirements-list li, .steps-list li, .feature-guide-list li, .alternatives-list li {
  margin-bottom: 0.8rem;
  line-height: 1.5;
}

/* 璇︽儏琛ㄦ牸鏍峰紡 */
.details-table {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1.5rem;
  margin: 2rem 0;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 0.8rem 0;
  border-bottom: 1px solid #e9ecef;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-weight: bold;
  color: #495057;
}

.detail-value {
  color: #6c757d;
}

/* 鎴浘缃戞牸鏍峰紡 */
.screenshots-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin: 2rem 0;
}

.screenshot-item img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

/* 鍔熻兘鐗规€ф牱寮?*/
.feature-item {
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1.5rem 0;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.feature-title {
  color: #2c3e50;
  margin-bottom: 1rem;
}

.feature-description {
  margin-bottom: 1rem;
  line-height: 1.6;
}

.feature-image {
  text-align: center;
  margin: 1rem 0;
}

.feature-image img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

/* 姣旇緝琛ㄦ牸鏍峰紡 */
.comparison-table {
  background: #ffffff;
  border-radius: 8px;
  overflow-x: auto;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  margin: 2rem 0;
}

.comparison-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  border-bottom: 1px solid #e9ecef;
}

.comparison-row:first-child {
  background: #f8f9fa;
  font-weight: bold;
}

.comparison-row:last-child {
  border-bottom: none;
}

.comparison-cell {
  padding: 1rem;
  text-align: center;
  border-right: 1px solid #e9ecef;
}

.comparison-cell:last-child {
  border-right: none;
}

.comparison-cell.feature-name {
  text-align: left;
  font-weight: bold;
  background: #f8f9fa;
}

.comparison-cell.official {
  background: #e3f2fd;
  color: #1976d2;
}

.comparison-cell.gb {
  background: #e8f5e8;
  color: #2e7d32;
}

/* FAQ鏍峰紡 */
.faq-item {
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1rem 0;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.faq-question {
  color: #2c3e50;
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.faq-answer {
  line-height: 1.6;
  color: #555;
}

/* 瀛愭爣棰樻牱寮?*/
.subsection-title {
  color: #34495e;
  font-size: 1.3rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
  border-left: 4px solid #3498db;
  padding-left: 1rem;
}

/* 娉ㄦ剰鏂囨湰鏍峰紡 */
.note-text {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 1rem;
  margin: 1rem 0;
  color: #856404;
}

/* 瀹夎鍥剧墖鏍峰紡 */
.install-image {
  text-align: center;
  margin: 2rem 0;
}

.install-image img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

/* Prós and Cons 鏍峰紡 */
.pros-cons-section {
  background: #f8f9fa;
  padding: 3rem 0;
}

.pros-cons-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  margin: 2rem 0;
}

.pros-column, .cons-column {
  background: #ffffff;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.pros-cons-title {
  color: #2c3e50;
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 0.5rem;
}

.pros-list, .cons-list {
  list-style: none;
  padding: 0;
}

.pros-list li, .cons-list li {
  margin-bottom: 1rem;
  padding: 0.8rem;
  border-radius: 4px;
  line-height: 1.6;
}

.pros-list li {
  background: #e8f5e8;
  border-left: 4px solid #2e7d32;
}

.cons-list li {
  background: #ffebee;
  border-left: 4px solid #d32f2f;
}

.pros-list li strong, .cons-list li strong {
  color: #2c3e50;
  display: block;
  margin-bottom: 0.3rem;
}

/* 鍝嶅簲寮忚璁?*/
@media (max-width: 768px) {
  h1 {
    font-size: 2rem;
  }
  
  h2 {
    font-size: 1.5rem;
  }
  
  h3 {
    font-size: 1.2rem;
  }
  
  .container {
    padding: 0 15px;
  }
  
  .hero-section {
    padding: 34px 0 36px;
  }

  .main-title {
    max-width: 520px;
    font-size: 32px;
    line-height: 1.16;
    margin-bottom: 16px;
  }

  .hero-tags {
    gap: 9px;
    margin-bottom: 24px;
  }

  .hero-tag {
    min-height: 36px;
    padding: 7px 12px;
    font-size: 13px;
  }

  .hero-logo {
    width: 168px;
    height: 168px;
    margin-bottom: 16px;
  }

  .hero-logo img {
    width: 128px !important;
    height: 128px !important;
    border-radius: 28px;
  }

  .download-btn {
    min-height: 72px;
    padding: 13px 22px !important;
    gap: 12px;
  }

  .download-title {
    font-size: 18px;
    line-height: 24px;
  }

  .download-subtitle {
    font-size: 14px;
    line-height: 20px;
  }

  .hero-checks {
    max-width: 430px;
    margin-bottom: 24px;
  }

  .hero-check {
    padding: 0 10px;
  }

  .hero-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .hero-stat {
    min-height: 82px;
    padding: 16px 12px;
    gap: 11px;
    justify-content: flex-start;
  }

  .hero-stat-value {
    font-size: 20px;
    line-height: 24px;
  }

  .hero-check:not(:last-child)::after {
    display: none;
  }
  
  .screenshots-grid {
    grid-template-columns: 1fr;
  }
  
  .pros-cons-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}
</style>
